import axios from 'axios';

import {
  PublicationNewAliasRequest,
  PublicationReclaimSearch,
} from '@/module/Author/Publication/model/PublicationTypes';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Book, BookRequest, BookSearchRequest } from './BookTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Book>>('/author/books/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Book>(`/author/books/${id}`).then(getData);
}

export function edit(id: Id, request: BookRequest) {
  return axios.put<Book>(`/author/books/${id}`, request).then(getData);
}

export function create(request: BookRequest) {
  return axios.post<Book>(`/author/books`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/books/${id}`).then(getData);
}

export function searchByIdentifiers(request: BookSearchRequest) {
  return axios
    .get<PublicationReclaimSearch>('/author/books/search/by-id', {
      params: {
        ...request,
      },
    })
    .then(getData);
}

export function addNewAlias(bookId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/books/${bookId}/add-new-alias`, request).then(getData);
}
